import { UsersPage } from 'src/pages/Users/index';
import { styled, Grid } from '@mui/material';

const WhiteContainerUsers = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3),
  padding: theme.spacing(0),
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)',
  '& >div': {
    width: '100%',
  },
}));

const TeamInfo: React.FC = () => {
  return (
    <WhiteContainerUsers container={true}>
      <UsersPage teamVersion={true} />
    </WhiteContainerUsers>
  );
};

export default TeamInfo;
